import { render, staticRenderFns } from "./importPart.vue?vue&type=template&id=64a54804&scoped=true&"
import script from "./importPart.vue?vue&type=script&lang=js&"
export * from "./importPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a54804",
  null
  
)

export default component.exports